import React from 'react'
import { Input as ShadcnInput } from '../ui/Input'
import { formatPriceInput } from '../../utils/formatters'
import { cn } from '@/lib/utils'

interface PriceInputProps {
 value: string
 onChange: (value: string) => void
 placeholder?: string
 disabled?: boolean
 className?: string
 id?: string
}

export const PriceInput: React.FC<PriceInputProps> = ({
 value,
 onChange,
 placeholder = 'R$ 0,00',
 disabled = false,
 className = '',
 id,
}) => {
 const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
 const formatted = formatPriceInput(e.target.value)
 onChange(formatted)
 }

 return (
 <ShadcnInput
 id={id}
 type="text"
 inputMode="decimal"
 value={value}
 onChange={handleChange}
 placeholder={placeholder}
 disabled={disabled}
 className={cn(className)}
 />
 )
}

